import {
  QA_REPORT_DEFINITIONS,
  type QaReportId,
  type QaReportOption,
} from "./qaReportOptions";
import type { QaReportCategoryKey } from "./qaReportTypes";

export type { QaReportCategoryKey } from "./qaReportTypes";

export type QaReportCategory = {
  key: QaReportCategoryKey;
  name: string;
  href: string;
  reportIds: QaReportId[];
};

export const QA_REPORT_CATEGORIES: QaReportCategory[] = [
  {
    key: "operations",
    name: "Operations reports",
    href: "/qa-reports/operations",
    reportIds: QA_REPORT_DEFINITIONS.filter(
      ({ category }) => category === "operations",
    )
      .sort((a, b) => a.categoryOrder - b.categoryOrder)
      .map(({ id }) => id),
  },
  {
    key: "inventory",
    name: "Inventory reports",
    href: "/qa-reports/inventory",
    reportIds: QA_REPORT_DEFINITIONS.filter(
      ({ category }) => category === "inventory",
    )
      .sort((a, b) => a.categoryOrder - b.categoryOrder)
      .map(({ id }) => id),
  },
  {
    key: "sales",
    name: "Sales reports",
    href: "/qa-reports/sales",
    reportIds: QA_REPORT_DEFINITIONS.filter(
      ({ category }) => category === "sales",
    )
      .sort((a, b) => a.categoryOrder - b.categoryOrder)
      .map(({ id }) => id),
  },
  {
    key: "finance",
    name: "Finance reports",
    href: "/qa-reports/finance",
    reportIds: QA_REPORT_DEFINITIONS.filter(
      ({ category }) => category === "finance",
    )
      .sort((a, b) => a.categoryOrder - b.categoryOrder)
      .map(({ id }) => id),
  },
  {
    key: "audit",
    name: "Audit reports",
    href: "/qa-reports/audit",
    reportIds: QA_REPORT_DEFINITIONS.filter(
      ({ category }) => category === "audit",
    )
      .sort((a, b) => a.categoryOrder - b.categoryOrder)
      .map(({ id }) => id),
  },
];

export function isQaReportCategoryKey(
  key: string | undefined | null,
): key is QaReportCategoryKey {
  return QA_REPORT_CATEGORIES.some((category) => category.key === key);
}

export function getQaReportCategory(
  key: string | undefined | null,
): QaReportCategory {
  if (isQaReportCategoryKey(key)) {
    return (
      QA_REPORT_CATEGORIES.find((category) => category.key === key) ??
      QA_REPORT_CATEGORIES[0]
    );
  }

  return QA_REPORT_CATEGORIES[0];
}

export function resolveQaReportCategoryKey(
  routeKey: string | undefined,
  overrideKey?: string,
): QaReportCategoryKey {
  const effectiveKey = overrideKey ?? routeKey;

  return isQaReportCategoryKey(effectiveKey) ? effectiveKey : "operations";
}

export function filterQaReportOptions(
  options: QaReportOption[],
  categoryKey: QaReportCategoryKey,
): QaReportOption[] {
  const optionsById = new Map(options.map((option) => [option.value, option]));

  return getQaReportCategory(categoryKey).reportIds.flatMap((reportId) => {
    const option = optionsById.get(reportId);

    return option ? [option] : [];
  });
}
